import React from "react";
import { RxCross2 } from "react-icons/rx";
import { File, FolderWithFiles } from "@solar-icons/react";

const FilterContainer = ({ setShowFilter }) => {
  return (
   <div className="fixed inset-0 top-0 z-50 flex justify-end items-start ">
      <div className="bg-four rounded-l-lg w-[220px] h-full max-h-screen flex flex-col ">
        <div className="flex-1 overflow-y-auto p-5 space-y-6">
          {/* Header */}
          <div className="flex justify-between items-center mb-2">
            <h2 className="text-lg font-bold text-gray-800">Filter</h2>
            <button onClick={() => setShowFilter(false)}>
              <RxCross2 fontSize={22} className="text-gray-600 hover:text-red-500" />
            </button>
          </div>

          {/* Type Filters */}
          <div>
            <h4 className="text-sm font-semibold text-gray-700 mb-2">Type</h4>
            <div className="flex items-center gap-2 mb-3">
              <File fontSize={20} className="text-gray-500" />
              <span className="text-sm text-gray-800">File</span>
              <input type="checkbox" className="ml-auto w-4 h-4 accent-blue-600" />
            </div>
            <div className="flex items-center gap-2">
              <FolderWithFiles fontSize={20} className="text-gray-500" />
              <span className="text-sm text-gray-800">Folder</span>
              <input type="checkbox" className="ml-auto w-4 h-4 accent-blue-600" />
            </div>
            <hr className="mt-4 border-gray-300" />
          </div>

          {/* People */}
          <div>
            <h4 className="text-sm font-semibold text-gray-700">People</h4>
            {[
              { name: "Madesh", email: "madesh@gmail.com" },
              { name: "Rakesh", email: "r@gmail.com" },
            ].map((person) => (
              <div key={person.email} className="flex gap-3 mt-4 items-center">
                <img
                  src="/assets/Ellipse 5.png"
                  alt={person.name}
                  className="w-6 h-6 rounded-full border"
                />
                <div className="flex flex-col">
                  <span className="text-sm font-medium text-gray-800">
                    {person.name}
                  </span>
                  <p className="text-xs text-gray-500">{person.email}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Ownership */}
          <div>
            <h4 className="text-sm font-semibold text-gray-700 mb-2">Ownership</h4>
            <div className="flex gap-2">
              {["All", "Owner", "Shared"].map((label) => (
                <button
                  key={label}
                  className="rounded-full px-4 py-1 border border-gray-300 text-xs text-gray-700 hover:bg-blue-100 transition"
                >
                  {label}
                </button>
              ))}
            </div>
          </div>

          {/* Sort By */}
          <div>
            <h4 className="text-sm font-semibold text-gray-700">Sort By</h4>
            {[
              "Name",
              "Date last added",
              "Date Added",
              "Date Modified",
              "Date Created",
              "Size",
            ].map((label) => (
              <div key={label} className="mt-3 flex justify-between items-center">
                <span className="text-sm text-gray-700">{label}</span>
                <input type="checkbox" className="w-4 h-4 accent-blue-600" />
              </div>
            ))}
          </div>

          {/* Date Filters */}
          <div>
            <h4 className="text-sm font-semibold text-gray-700">Filter by Date</h4>
            {["Today", "Yesterday", "Last 15 Days", "Last 30 Days", "Last 1 Month"].map(
              (label) => (
                <div key={label} className="mt-3 flex justify-between items-center">
                  <span className="text-sm text-gray-700">{label}</span>
                  <input type="checkbox" className="w-4 h-4 accent-blue-600" />
                </div>
              )
            )}
          </div>

          {/* Action Buttons */}
          <div className="flex justify-between mt-6">
            <button className="px-4 py-2 rounded-md border text-sm border-gray-300 text-gray-700 hover:bg-gray-100">
              Reset
            </button>
            <button className="px-4 py-2 rounded-md text-sm bg-blue-600 text-white hover:bg-blue-700">
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterContainer;
